<template>
  <section class="noPrize--page" v-if="show">
    <van-overlay :show="show" z-index="2"/>
    <div class="noPrize__main">
      <img :src="selectNoPrize()" alt="" class="noPrize__img">
      <div class="noPrize__btns">
        <img src="@/assets/noPrize-again.png" @click="handlePrizeAgain" alt="" class="noPrize__btns--item">
        <img src="@/assets/noPrize-share.png" @click="handleOpenShare" alt="" class="noPrize__btns--item">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
    }
  },
  data () {
    return {
      noPrize: {
        1: 'https://qhd-icbc.oss-cn-shenzhen.aliyuncs.com/poster-tag/noPrize-img1.png',
        2: 'https://qhd-icbc.oss-cn-shenzhen.aliyuncs.com/poster-tag/noPrize-img2.png',
        3: 'https://qhd-icbc.oss-cn-shenzhen.aliyuncs.com/poster-tag/noPrize-img3.png'
      }
    }
  },
  methods: {
    selectNoPrize () {
      const random = Math.floor(Math.random() * 3 + 1)
      return this.noPrize[random]
    },
    handleOpenShare () {
      this.$emit('openShare')
    },
    handlePrizeAgain () {
      this.$emit('again')
    }
  }
}
</script>

<style lang="scss">
.noPrize--page{
  .noPrize__{
    &btns{
        position: absolute;
        z-index: 3;
        top: 861px;
        padding: 0 121px;
        height: 90px;
        &--item{
          width: 229px;
          &:last-child{
            margin-left: 45px;
          }
        }
      }
    &img{
      position: absolute;
      z-index: 3;
      top: 210px;
      left: 0;
      right: 0;
      width: 630px;
      margin: auto;
    }
  }
}
</style>